<template>
  <div id="main-board">
    <div class="m_title">OAO跨境电商平台数据看板</div>
    <div class="exit">
      <a href="/"><i></i>退出</a>
    </div>

    <div class="block1">
      <div class="boxall">
        <div class="alltitle">
          <div class="icon"><img src="~@/assets/board/icon01.png" /></div>
          数据曲线
        </div>
        <div class="allnav" style="height: 13vw">
          <div style="height: 13vw; position: relative">
            <div class="table_line">
              <ul>
                <li><span style="background: #ffd200"></span>新增商家</li>
                <li><span style="background: #3bf3ff"></span>新增入驻商街</li>
              </ul>
            </div>
            <monitoring
              ref="monitoring"
              :busiData="busi"
              :busiinData="busiin"
            ></monitoring>
          </div>
        </div>
        <div class="boxfoot"></div>
      </div>
    </div>

    <div class="block2">
      <div class="boxall">
        <div class="alltitle">
          <div class="icon"><img src="~@/assets/board/icon02.png" /></div>
          商家分类汇总TOP5
        </div>
        <div class="allnav" style="height: 13vw">
          <bar-chart ref="barChart" :data="ShoptypeStat" />
        </div>
        <div class="boxfoot"></div>
      </div>
    </div>

    <div class="block3">
      <div class="boxall">
        <div class="alltitle">
          <div class="icon"><img src="~@/assets/board/icon03.png" /></div>
          营销渠道接入占比
        </div>
        <div class="allnav" style="height: 12vw">
          <doughnut ref="doughnut"></doughnut>
          <!-- <div class="date_img">
              <div class="img"></div>
            </div> -->

          <!-- <div class="date_img_list">
              <ul>
                <li>
                  <div class="l_icon" style="background: #ffd200"></div>
                  淘宝<span>（30%）</span>
                </li>
                <li>
                  <div class="l_icon" style="background: #00d985"></div>
                  微信小程序<span>（20%）</span>
                </li>
                <li>
                  <div class="l_icon" style="background: #ed3d3d"></div>
                  抖音<span>（20%）</span>
                </li>
                <li>
                  <div class="l_icon" style="background: #1dceda"></div>
                  京东<span>（10%）</span>
                </li>
                <li>
                  <div class="l_icon" style="background: #fff"></div>
                  拼多多<span>（10%）</span>
                </li>
                <li>
                  <div class="l_icon" style="background: #b956ff"></div>
                  天猫<span>（10%）</span>
                </li>
              </ul>
            </div> -->
        </div>
        <div class="boxfoot"></div>
      </div>
    </div>

    <div class="block4">
      <div class="boxall">
        <div class="alltitle">
          <div class="icon"><img src="~@/assets/board/icon04.png" /></div>
          货源概况
        </div>
        <div class="allnav" style="height: 13vw">
          <div class="link">
            <ul>
              <li>
                <div class="box">
                  <div class="img"><img src="~@/assets/board/b01.png" /></div>
                  <div class="name">商品类别</div>
                  <div class="num">{{ GoodsOverview.GoodsType }}</div>
                </div>
              </li>
              <li>
                <div class="box">
                  <div class="img"><img src="~@/assets/board/b02.png" /></div>
                  <div class="name">商品总数</div>
                  <div class="num">{{ GoodsOverview.GoodsCount }}</div>
                </div>
              </li>
              <li>
                <div class="box">
                  <div class="img"><img src="~@/assets/board/b03.png" /></div>
                  <div class="name">国产品牌</div>
                  <div class="num">{{ GoodsOverview.DomesticBrands }}</div>
                </div>
              </li>
              <li>
                <div class="box">
                  <div class="img"><img src="~@/assets/board/b04.png" /></div>
                  <div class="name">进口品牌</div>
                  <div class="num">{{ GoodsOverview.ImportedBrands }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="boxfoot"></div>
      </div>
    </div>

    <div class="block5">
      <div class="boxall">
        <div class="alltitle">
          <div class="icon"><img src="~@/assets/board/icon05.png" /></div>
          销量排行
        </div>
        <div class="allnav" style="height: 13vw">
          <div class="table">
            <table>
              <tbody>
                <tr>
                  <th>排行</th>
                  <th>商品类别</th>
                  <th>销售额</th>
                </tr>
                <tr v-for="(item,index) in saleRank" :key="item.TypeName">
                  <td>{{index+1}}</td>
                  <td>{{ item.TypeName }}</td>
                  <td style="color: #3bf3ff">{{ item.Amount }}元</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="boxfoot"></div>
      </div>
    </div>

    <div class="block6">
      <div class="boxall">
        <div class="alltitle">
          <div class="icon"><img src="~@/assets/board/icon06.png" /></div>
          订单趋势
        </div>
        <div class="allnav" style="height: 12vw">
          <div>
            <line-chart ref="lineChart" :data="OrderStat" />
          </div>
        </div>
        <div class="boxfoot"></div>
      </div>
    </div>

    <div class="center_date">
      <ul>
        <li>
          <div class="date_box">
            <div class="img"><img src="~@/assets/board/c01.png" /></div>
            <div class="inf">
              <div class="name">商家总数</div>
              <div class="num">
                <b>{{ data.BusinessCount }}</b>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div class="date_box">
            <div class="img"><img src="~@/assets/board/c02.png" /></div>
            <div class="inf">
              <div class="name">店铺总数</div>
              <div class="num">
                <b>{{ data.BusinessShopCount }}</b>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div class="date_box">
            <div class="img"><img src="~@/assets/board/c03.png" /></div>
            <div class="inf">
              <div class="name">商街总数</div>
              <div class="num">
                <b>{{ data.BstrCount }}</b>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import monitoring from "@/components/board/monitoring";
import barChart from "@/components/board/barChart";
import lineChart from "@/components/board/lineChart";
import doughnut from "@/components/board/doughnut";

export default {
  components: {
    monitoring,
    barChart,
    lineChart,
    doughnut,
  },
  data() {
    return {
      api: require("@/api/sy/user").default,
      NowTime: new Date().toLocaleTimeString(),
      data: {
        BusinessCount: 0,
        BusinessShopCount: 0,
        BstrCount: 0,
      },
      busi: [],
      busiin: [],
      ShoptypeStat: [],
      OrderStat: [],
      ready: false,
      saleRank: [],
      GoodsOverview: {},
      // fifthRank:{TypeName:"",Amount:""},
      // secondRank:{TypeName:"",Amount:""},
      // thirdRank:{TypeName:"",Amount:""},
      // fourthRank:{TypeName:"",Amount:""},
      // fifthRank:{TypeName:"",Amount:""}
    };
  },
  computed: {
    NowDate() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var day = now.getDate(); //得到天
      if (day < 10) {
        day = "0" + day;
      }
      month = month + 1;
      month = month.toString().padStart(2, "0");
      /**
       * 获取月初到月末，年初到年末
       * **/
      return `${year}年${month}月${day}日`;
    },
    Month() {
      const date = new Date();
      switch (date.getDay()) {
        case 0:
          return "星期天";
          break;
        case 1:
          return "星期一";
          break;
        case 2:
          return "星期二";
          break;
        case 3:
          return "星期三";
          break;
        case 4:
          return "星期四";
          break;
        case 5:
          return "星期五";
          break;
        case 6:
          return "星期六";
          break;
      }
      // return date.getDay();
    },
  },

  mounted() {
    this.api.getWorkbench().then((res) => {
      if (res.Code == 0) {
        this.$refs.barChart.drawLine(res.Data.ShoptypeStat);
        this.$refs.doughnut.initChart(res.Data.ShoplinkStat);
        this.busi = res.Data.BusinessShopStat2;
        this.busiin = res.Data.BstrinStat2;
        this.GoodsOverview = res.Data.GoodsOverview;
        this.saleRank = res.Data.SaleRanks;
        // if (this.saleRank.length > 0) {
        //   this.firstRank = this.saleRank[0];
        //   if(this.saleRank.length>1){
        //   this.secondRank = this.saleRank[1];

        //   }
        //   if(this.saleRank.length>2){
        //   this.thirdRank = this.saleRank[2];

        //   }
        //   if(this.saleRank.length>3){
        //   this.fourthRank = this.saleRank[3];

        //   }
        //   if(this.saleRank.length>4){
        //   this.fifthRank = this.saleRank[4];

        //   }
        // }

        //------------------------------------
        // var arr = [
        //   { Name: "12-06", Value: 750 },
        //   { Name: "12-07", Value: 550 },
        //   { Name: "12-08", Value: 800 },
        //   { Name: "12-09", Value: 300 },
        //   { Name: "12-10", Value: 190 },
        //   { Name: "12-11", Value: 650 },
        //   { Name: "12-12", Value: 500 },
        // ]
        this.$refs.lineChart.drawLine(res.Data.OrderStat);
        //------------------------------------
        this.$nextTick(() => {
          this.$refs.monitoring.drawLine();
        });
        this.data = res.Data;
      }
    });
    // const timer = setInterval(() => {
    //   this.NowTime = new Date().toLocaleTimeString(); // 修改数据date
    // }, 1000);
    // this.$once('hook:beforeDestroy', () => {
    //   clearInterval(timer);
    // });
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
#main-board {
  width: 100vw;
  height: 56.25vw;
  background: url(../assets/board/bg.jpg) center center no-repeat;
  background-size: 100%;
  position: relative;
  color: #fff;
}
#main-board * {
  box-sizing: content-box;
}
body,
div,
address,
blockquote,
iframe,
ul,
ol,
dl,
dt,
dd,
li,
dl,
h1,
h2,
h3,
h4,
h5,
h6,
p,
pre,
table,
caption,
th,
td,
form,
legend,
fieldset,
input,
button,
select,
textarea {
  margin: 0;
  padding: 0;
}
ol,
ul,
li {
  list-style-type: none;
}
body {
  margin: 0 auto;
  background: #000d37;
  color: #fff;
  font: 12px "微软雅黑", Arial;
}
a {
  color: #fff;
  text-decoration: none;
}
a:hover {
  color: #fff;
  text-decoration: underline;
}
a img {
  border: 0;
}
img {
  display: block;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  display: inline-block;
}
/* Hides from IE-mac \*/
* html .clearfix {
  height: 1%;
}
.clearfix {
  display: block;
} /* End hide from IE-mac */

.fl {
  float: left;
}
.fr {
  float: right;
}
.h10 {
  clear: both;
  width: 100%;
  height: 10px;
  font-size: 0px;
  line-height: 0px;
}

.m_title {
  height: 4.8vw;
  text-align: center;
  line-height: 4.8vw;
  font-size: 1.8vw;
  font-weight: bold;
}

.exit {
  position: absolute;
  right: 1vw;
  top: 0;
}
.exit a {
  height: 3.6vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8vw;
  color: #63fff2;
}
.exit a i {
  display: block;
  height: 1vw;
  width: 1vw;
  margin-right: 0.3vw;
  background: url(../assets/board/exit.png) 0 0 no-repeat;
  background-size: 100%;
}

.boxall {
  border: 1px solid rgba(99, 255, 242, 0.27);
  background: rgba(101, 132, 226, 0.1);
  position: relative;
  z-index: 10;
  height: 100%;
}
.boxall:before,
.boxall:after {
  position: absolute;
  width: 0.5vw;
  height: 0.5vw;
  content: "";
  border-top: 0.15vw solid #02a6b5;
  top: 0;
}
.boxall:before,
.boxfoot:before {
  border-left: 0.15vw solid #02a6b5;
  left: 0;
}
.boxall:after,
.boxfoot:after {
  border-right: 0.15vw solid #02a6b5;
  right: 0;
}

.boxfoot {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
}
.boxfoot:before,
.boxfoot:after {
  position: absolute;
  width: 0.5vw;
  height: 0.5vw;
  content: "";
  border-bottom: 0.15vw solid #02a6b5;
  bottom: 0;
}

.block1 {
  position: absolute;
  left: 1vw;
  top: 6vw;
  width: 28.5vw;
}
.block2 {
  position: absolute;
  left: 1vw;
  top: 23vw;
  width: 28.5vw;
}
.block3 {
  position: absolute;
  left: 1vw;
  top: 40vw;
  width: 28.5vw;
}
.block4 {
  position: absolute;
  right: 1vw;
  top: 6vw;
  width: 28.5vw;
}
.block5 {
  position: absolute;
  right: 1vw;
  top: 23vw;
  width: 28.5vw;
}
.block6 {
  position: absolute;
  right: 1vw;
  top: 40vw;
  width: 28.5vw;
}

.alltitle {
  font-size: 0.9vw;
  color: #fff;
  line-height: 1.2vw;
  padding: 0.7vw 0 0.2vw 0.2vw;
  overflow: hidden;
  font-weight: bold;
}
.alltitle .icon {
  float: left;
  width: 1.2vw;
  height: 1.2vw;
  padding: 0 0.3vw;
}
.alltitle .icon img {
  width: 100%;
}
.allnav {
  position: relative;
  padding: 0.6vw;
}

.date_img {
  width: 12vw;
  float: left;
  padding-top: 1.6vw;
}
.date_img .img {
  width: 8.6vw;
  height: 8.6vw;
  margin: 0 auto;
  background: #fff;
  border-radius: 50%;
}

.date_img_list {
  float: right;
  width: 14vw;
  padding-top: 1.2vw;
}
.date_img_list ul li {
  line-height: 1.5;
  vertical-align: middle;
  padding: 0.2vw 0;
  font-size: 0.8vw;
}
.date_img_list ul li .l_icon {
  display: inline-block;
  width: 0.7vw;
  height: 0.7vw;
  border-radius: 50%;
  margin-right: 0.6vw;
}
.date_img_list ul li span {
  color: #3bf3ff;
}

.table_line {
  position: absolute;
  right: 0;
  top: -1.8vw;
}
.table_line ul li {
  float: left;
  font-size: 0.75vw;
  line-height: 1.2vw;
  padding-left: 1.5vw;
  line-height: 1.2vw;
}
.table_line ul li span {
  display: block;
  float: left;
  height: 0.2vw;
  width: 1vw;
  line-height: 1.2vw;
  margin: 0.5vw 0.5vw 0 0;
}

.center_date {
  position: absolute;
  left: 31vw;
  top: 5.5vw;
  width: 38vw;
}
.center_date ul li {
  float: left;
  width: 33.3%;
}
.center_date ul li .date_box {
  border: 1px solid rgba(99, 255, 242, 0.27);
  background: rgba(101, 132, 226, 0.1);
  margin: 0.5vw;
  border-radius: 1vw;
  padding: 1.2vw 0;
}
.center_date ul li .date_box .img {
  border: 1px solid rgba(25, 186, 139, 0.3);
  background: rgba(99, 255, 242, 0.2);
  padding: 0.8vw;
  width: 3vw;
  height: 3vw;
  border-radius: 1.5vw;
  margin: 1vw auto 0 auto;
}
.center_date ul li .date_box .img img {
  width: 100%;
}
.center_date ul li .date_box .inf {
  margin: 0.6vw 0 0 0;
  line-height: 2vw;
  text-align: center;
  font-size: 0.95vw;
}
.center_date ul li .date_box .inf .num {
  color: #ffd200;
}
.center_date ul li .date_box .inf .num b {
  font-size: 1.6vw;
}

.link ul li {
  float: left;
  width: 50%;
}
.link ul li .box {
  background: url(../assets/board/block_bg.png) top left no-repeat;
  background-size: 100%;
  margin: 0.3vw;
  height: 6vw;
}
.link ul li .img {
  width: 2.7vw;
  height: 2.7vw;
  float: left;
  padding: 1.5vw 0 0 1.5vw;
}
.link ul li .img img {
  width: 100%;
}
.link ul li .name {
  font-size: 0.95vw;
  padding: 1.2vw 0 0 5.2vw;
}
.link ul li .num {
  font-size: 1.6vw;
  color: #ffd200;
  font-weight: bold;
  padding: 0 0 0 5.2vw;
}
.link .box {
  border: 0;
}

.table table {
  border-collapse: collapse;
  width: 100%;
}
.table table tr th {
  font-size: 0.95vw;
  padding: 0.32vw 0;
  line-height: 1.5;
  text-align: center;
  font-weight: normal;
  border: 1px solid #225177;
  background: rgba(99, 255, 242, 0.1);
}
.table table tr td {
  font-size: 0.95vw;
  padding: 0.32vw 0;
  line-height: 1.5;
  text-align: center;
  border: 1px solid #225177;
}
</style>